export default __webpack_public_path__ + "static/italy_superenalotto-3909cf87594f55ec934ac358f4e35bf0.png";